import { render, staticRenderFns } from "./TouristList.vue?vue&type=template&id=10e2a5e3&scoped=true"
import script from "./TouristList.vue?vue&type=script&lang=js"
export * from "./TouristList.vue?vue&type=script&lang=js"
import style0 from "./TouristList.vue?vue&type=style&index=0&id=10e2a5e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2a5e3",
  null
  
)

export default component.exports